export const formatDate = (dateString, unit) => {
  const date = new Date(dateString);

  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  let formattedDate = '';

  switch (unit) {
    case 'month':
      formattedDate = `${month}/${year}`; // Format as "MM/YYYY"
      break;

    case 'year':
      formattedDate = `${year}`; // Format as just "YYYY"
      break;

    case 'quarter':
      {
        const quarter = Math.floor(date.getMonth() / 3) + 1; // Calculate quarter and format as "QX/YYYY"
        formattedDate = `Q${quarter}/${year}`;
      }
      break;

    default:
      formattedDate = dateString;
      break;
  }

  return formattedDate;
};
